var React = require('react');

function IconArrowBack (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.607 7.998c.528.502.55 1.316.062 1.832l-4.146 3.987a.4.4 0 0 0 .277.688h10.4a1.2 1.2 0 1 1 0 2.4H13.8a.4.4 0 0 0-.283.683l4.02 4.019c.44.507.413 1.299-.081 1.793a1.329 1.329 0 0 1-1.813.062l-7.679-7.758 7.833-7.759c.509-.48 1.32-.46 1.81.053z","fill":"#000","fillRule":"evenodd"}));
}

IconArrowBack.defaultProps = {"width":"33","height":"32","viewBox":"0 0 33 32"};

module.exports = IconArrowBack;

IconArrowBack.default = IconArrowBack;
